module.exports = __webpack_public_path__ + "img/22.e05a53f1.png";